<!--
* @Author: zhangping
* @Date: 2026-02-06 09:17:13
* @Description: 地区地图
-->

<template>
    <div class="rm por">
        <div class="rm-warehouse">
            <Table
                size="small"
                max-height="200"
                :columns="columns"
                border
                noDataText="暂无仓库地址!"
                :data="warehouseVOS"
            />
        </div>
        <div id="regionMapContainer"></div>
    </div>
</template>

<script>
import { apiStoreFindByStoreId } from '@/api/customer';

let map = null; // 地图实例
let markers = []; // 所有的点标记
export default {
    props: {
        storeId: {
            type: String,
            default: '',
        },
        mapForm: {
            type: Object,
            default: () => {
                return {
                    address: '',
                    lng: '',
                    lat: '',
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                };
            },
        },
    },
    data() {
        return {
            map: null,
            warehouseVOS: [],
            columns: [
                { title: '类型', key: 'type', width: 90 },
                { title: '地址', key: 'address' },
                { title: '经度', key: 'lng', width: 120 },
                { title: '维度', key: 'lat', width: 120 },
            ],
        };
    },
    mounted() {
        map = new AMap.Map('regionMapContainer', {
            zoom: 12,
            scrollWheel: true,
        });
    },
    destroyed() {
        map = null;
        markers = [];
    },
    methods: {
        // 获取仓库列表数据
        async getData() {
            this.$Message.loading({ content: '加载中...', duration: 0 });
            try {
                const res = await apiStoreFindByStoreId(this.storeId);
                // 清空地图所有marker，重新渲染数据
                map.remove(markers);
                markers = [];
                this.$Message.destroy();
                let _list = [
                    {
                        address: this.mapForm.address,
                        longitude: this.mapForm.lng,
                        latitude: this.mapForm.lat,
                        type: '门店',
                    },
                    ...res,
                ];
                map.setCenter([this.mapForm.lng, this.mapForm.lat]);
                this.warehouseVOS = _list.map((item, index) => {
                    let marker = new AMap.Marker({
                        map: map,
                        icon: new AMap.Icon({
                            size: new AMap.Size(32, 32), // 设置图标的宽高
                            image:
                                item.type === '门店'
                                    ? 'http://webapi.amap.com/ui/1.0/ui/misc/PositionPicker/assets/position-picker.png?v=1.0.11&key=372e94fb9f9e7e54c61d2959eaf92a71'
                                    : 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
                            imageSize: item.type === '门店' ? new AMap.Size(32, 32) : null, // 图片的实际大小
                        }),
                        position: new AMap.LngLat(item.longitude, item.latitude), // 基点位置
                    });
                    marker.id = item.id;
                    marker.address = item.address;
                    marker.type = item.type || '仓库';
                    marker.index = index;
                    marker.lat = item.latitude;
                    marker.lng = item.longitude;
                    markers.push(marker);
                    return {
                        address: item.address,
                        lng: item.longitude,
                        lat: item.latitude,
                        index,
                        type: item.type || '仓库',
                    };
                });
            } catch (error) {
                this.$Message.destroy();
            }
        },
    },
};
</script>

<style lang="less" scoped>
.rm {
    .rm-warehouse {
        width: 800px;
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0.9;
        z-index: 999999;
    }
    #regionMapContainer {
        width: 100%;
        height: 600px;
    }
}
</style>
